module.exports = __webpack_public_path__ + "img/246.52a9a1ea.png";